module.exports = "<go-wrapper [title]=\"'Участвует в ивентах'\"\n            [document]=\"document\"\n            [componentType]=\"componentType\">\n  <nv-game-events [document]=\"document\"\n           [propertyName]=\"GO_COMPONENTS.GAME_EVENTS\"></nv-game-events>\n\n</go-wrapper>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/go/go-game-events/go-game-events.component.html
// module id = ../../../../../src/app/components/go/go-game-events/go-game-events.component.html
// module chunks = 0